import { useEffect } from "react";

const UseTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - Le Monde de Doma`;
  }, [title]);
  return null;
};

export default UseTitle;
